let state = { src: null, playing: false, position: 0, duration: 0 };
const subs = new Set();

export const voiceBus = {
    get: () => state,
    emit(patch = {}) {
        state = { ...state, ...patch };
        // eslint-disable-next-line no-console
        console.log("[voiceBus.emit]", patch, "->", state);
        subs.forEach(fn => {
            try { fn(state); } catch (e) { console.warn("[voiceBus subscriber error]", e); }
        });
    },
    subscribe(fn) {
        subs.add(fn);
        return () => subs.delete(fn);
    }
};
